import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <>
      <nav id="mainNav" className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="container nav-inner">
          {/* Logo */}
          <a href="#hero" className="nav-logo-text" onClick={(e) => handleAnchorClick(e, '#hero')}>
            {/* <span className="logo-go">Go</span>Snap */}
            <img src="/white_nobg.png" alt="GoSnap Logo" className="logo-go" />
          </a>

          {/* Desktop Menu */}
          <div className="nav-menu">
            {[
              { label: 'How It Works', href: '#how' },
              { label: 'Services', href: '#services' },
              { label: 'Creators', href: '#creators' },
              { label: 'Pricing', href: '#pricing' },
              { label: 'Contact', href: '#contact' },
            ].map((item) => (
              <a key={item.href} href={item.href} onClick={(e) => handleAnchorClick(e, item.href)}>
                {item.label}
              </a>
            ))}
          </div>

          {/* Desktop Actions */}
          <div className="nav-actions">
            <a href="#creators-join" className="btn-outline nav-btn-sm" onClick={(e) => handleAnchorClick(e, '#creators-join')}>
              Become a Creator
            </a>
            <a href="#contact" className="btn-primary nav-btn-sm" onClick={(e) => handleAnchorClick(e, '#contact')}>
              Book Now
            </a>
          </div>

          {/* Hamburger */}
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {[
          { label: 'How It Works', href: '#how' },
          { label: 'Services', href: '#services' },
          { label: 'Creators', href: '#creators' },
          { label: 'Pricing', href: '#pricing' },
          { label: 'Contact', href: '#contact' },
        ].map((item) => (
          <a key={item.href} href={item.href} onClick={(e) => handleAnchorClick(e, item.href)}>
            {item.label}
          </a>
        ))}
        <a href="#creators-join" className="btn-outline" onClick={(e) => handleAnchorClick(e, '#creators-join')}>
          Become a Creator
        </a>
        <a href="#contact" className="btn-primary" onClick={(e) => handleAnchorClick(e, '#contact')}>
          Book a Creator
        </a>
      </div>
    </>
  );
};

export default Navbar;
